export const setIntervalX = (handler: (...args: any) => void, timeout: number, times: number) => {
  let x = 0
  const intervalID = setInterval(() => {
     handler()
     if (++x === times) {
         window.clearInterval(intervalID)
     }
  }, timeout)
}